import { ColorOption } from './color-palete-map';
import styles from './color-picker.module.scss';

export const DropDownInput = ({
  selected,
  showColorExample,
  inputValue,
  toggleDropdown,
  handleKeyDown,
  handleSearch,
}: {
  selected: ColorOption | null;
  showColorExample: boolean;
  inputValue: string;
  toggleDropdown: () => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <div
      className={styles.toggle}
      onClick={toggleDropdown}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label="Hexcolor"
    >
      {selected?.hex && showColorExample && (
        <span
          className={styles.colorBox}
          style={{ backgroundColor: selected.hex }}
        />
      )}
      <input
        className={styles.input}
        type="text"
        value={inputValue}
        onChange={handleSearch}
      />
    </div>
  );
};
